export const FacilitiesAndServicesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.25 7.25h13.5V6.125A1.125 1.125 0 0 0 14.625 5H3.375A1.125 1.125 0 0 0 2.25 6.125V7.25Zm0 1.125V14a1.125 1.125 0 0 0 1.125 1.125h11.25A1.125 1.125 0 0 0 15.75 14V8.375H2.25Zm1.125-4.5h11.25a2.25 2.25 0 0 1 2.25 2.25V14a2.25 2.25 0 0 1-2.25 2.25H3.375A2.25 2.25 0 0 1 1.125 14V6.125a2.25 2.25 0 0 1 2.25-2.25Z"
    />
    <path
      fill="currentColor"
      d="M6.75 2.75v1.125h4.5V2.75h-4.5Zm0-1.125h4.5a1.125 1.125 0 0 1 1.125 1.125v1.125A1.125 1.125 0 0 1 11.25 5h-4.5a1.125 1.125 0 0 1-1.125-1.125V2.75A1.125 1.125 0 0 1 6.75 1.625Z"
    />
  </svg>
);
